import { useEffect } from "react";
import { useDataProvider, useListContext, useNotify, useRefresh, useUnselectAll } from "react-admin";
import { Box, Button } from "@mui/material";
import { ATTESTATIONS, AttestationStatus, StudentServicePath } from "utils/constants";
import { Sync } from "@mui/icons-material";
import { studentRequests } from "api/studentApi";
import { useNotifyError } from "utils/useNotifyError";

const ActionButtons = ({ setIsSelectedIds }) => {
  const { data, selectedIds } = useListContext();
  const refresh = useRefresh();
  const notify = useNotify();
  const notifyError = useNotifyError();
  const dataProvider = useDataProvider();
  const unselectAll = useUnselectAll(`${StudentServicePath}${ATTESTATIONS}`);

  const updateIds = async statusId => {
    const body = {
      attestationIds: selectedIds,
      toStatus: statusId,
    };
    try {
      await dataProvider.customRequest(studentRequests.updateAttestationsStatus(), body, "PUT");
      notify("Статусът беше променен успешно", { type: "success" });
      unselectAll();
      setIsSelectedIds(false);
      refresh();
    } catch (error) {
      notifyError(error);
    }
  };

  useEffect(() => {
    refresh();
  }, [data, refresh]);

  useEffect(() => {
    setIsSelectedIds(selectedIds?.length > 0);
  }, [selectedIds, setIsSelectedIds]);

  return (
    <Box>
      <Button
        variant="contained"
        color="warning"
        mt={2}
        onClick={() => updateIds(AttestationStatus.AwaitingVerification)}
      >
        <Sync /> Смени статус на Чака заверка
      </Button>
      <Button
        variant="contained"
        color="primary"
        mt={2}
        sx={{ margin: "1rem" }}
        onClick={() => updateIds(AttestationStatus.Verified)}
      >
        <Sync /> Смени статус на заверен
      </Button>
      <Button
        variant="contained"
        color="error"
        mt={2}
        onClick={() => updateIds(AttestationStatus.Unverified)}
      >
        <Sync /> Смени статус на незаверен
      </Button>
    </Box>
  );
};

export default ActionButtons;
